<template>
  <div>
    <DialogBase
      v-model="inputValue"
      :title="
        $t('common.common_note-phrase') +
        (editMode ? $t('common.common_edit') : $t('common.common_register'))
      "
      :width="width"
    >
      <div class="px-5 pb-5">
        <InputFormNew
          v-model="inputData"
          :detail="items"
          :titleCols="inputFormStyle.titleCols"
          :contentsCols="inputFormStyle.contentsCols"
          :master-data="notePhrase"
        >
          <template #body="{ item }">
            <v-textarea
              outlined
              v-model="item.body"
              :placeholder="$t('common.input_input_1')"
              hide-details
            ></v-textarea>
          </template>
        </InputFormNew>
        <NormalButton
          :text="buttonName"
          textSize="16px"
          height="50px"
          width="100%"
          class="pt-5"
          @click.native="complete()"
        />
      </div>
    </DialogBase>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import DialogBase from '@/components/layouts/Dialogs/DialogBase'
import { InputFormNew, NormalButton } from '@/components/items'
export default {
  components: {
    DialogBase,
    InputFormNew,
    NormalButton
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    buttonName: { default: 'common.input_save' },
    notePhraseData: { type: Object, require: false, default: () => ({}) },
    editMode: { type: Boolean, require: false, default: false }
  },
  data: () => ({
    inputFormStyle: {
      titleCols: 3,
      contentsCols: 9
    },
    inputData: {},
    notePhrase: [],
    items: [
      {
        name: 'title',
        text: 'common.input_title',
        required: true
      },
      {
        name: 'sortNumber',
        text: 'common.input_sort-number',
        required: true,
        placeholder: '',
        cols: Math.ceil(5),
        component: 'SelectSortNumber'
      },
      {
        name: 'body',
        text: 'common.input_content',
        required: true,
        textPositionStart: true
      }
    ]
  }),

  created() {
    this.init()
  },

  methods: {
    ...mapActions('NotePhrase', ['registerNotePhrase', 'editNotePhrase']),
    ...mapGetters('NotePhrase', [
      'getMaxSortNumber',
      'getNotePhraseListFromState'
    ]),

    init() {
      const formatData = { ...this.notePhraseData }
      formatData.sortNumber = this.editMode
        ? this.notePhraseData.sortNumber
        : this.getMaxSortNumber() + 1

      this.inputData = formatData
      this.notePhrase = this.getNotePhraseListFromState()
    },
    async complete() {
      if (this.editMode) {
        this.inputData.id = this.inputData.notePhraseId
      }
      const success = this.editMode
        ? await this.editNotePhrase(this.inputData)
        : await this.registerNotePhrase(this.inputData)

      if (success) {
        this.$emit('success')
      }
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    inputValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) this.init()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.baseStyle {
  font-size: 14px;
}
</style>
